import React, { useState } from 'react';
import { SavedContainer, SavedHeaderButton, SavedHeaderInfo, SavedHeaderCircle, SavedHeaderClose, CardContainer } from "./CrewBuilderElements"
import SavedTeamRow from './SavedTeamRow';

const SavedHeader = ({ teams }) => {

    const [displayTeams, setDisplayTeams] = useState(false);

    const handleShow = () => e => {
        e.preventDefault()
        setDisplayTeams(!displayTeams)
    }

    return (
        <div>
            <SavedContainer>
                <SavedHeaderInfo primary={true}>
                    Saved Teams
                </SavedHeaderInfo>
                <SavedHeaderButton primary={displayTeams} onClick={handleShow()}>
                    Saved Teams
                    {displayTeams ? (

                        <SavedHeaderClose />
                    ) :
                        <SavedHeaderCircle>{teams.length}</SavedHeaderCircle>
                    }
                </SavedHeaderButton>
            </SavedContainer>
            <>
                {displayTeams ? (
                    teams.map((team, key) =>
                        <SavedTeamRow id={key + 1} team={team} />
                    )
                ) :
                    <></>
                }
            </>

        </div>
    )
};

export default SavedHeader;